import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";

import { RootState, AppDispatch } from "../index"; // Adjust the path to your store configuration

// Define types for the useSelector and useDispatch hooks with our RootState and AppDispatch types
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
export const useAppDispatch = () => useDispatch<AppDispatch>();
